export enum PackageStatus {
  FORMING = 'FORMING',
  FORMED = 'FORMED',
  PAYING = 'PAYING',
  CLOSED = 'CLOSED',
}

type PackageStatusRecord = Record<PackageStatus, string>;

export const PackageStatusMapped: PackageStatusRecord = {
  [PackageStatus.FORMING]: 'ФОРМИРУЕТСЯ',
  [PackageStatus.FORMED]: 'СФОРМИРОВАН',
  [PackageStatus.PAYING]: 'ВЫПЛАТА',
  [PackageStatus.CLOSED]: 'ЗАКРЫТ',
};

export const resolvePackageStatusFromDeals = (
  dealsCount: number,
  remainingDeals: number
): PackageStatus => {
  if (remainingDeals > 0) {
    return PackageStatus.FORMING;
  }

  if (dealsCount > 0) {
    return PackageStatus.FORMED;
  }

  return PackageStatus.FORMED;
};

export const resolveInvestmentPackageStatus = (pkg: {
  status: PackageStatus | null;
  dealsCount: number;
  remainingDeals: number;
}): PackageStatus => {
  return pkg.status ?? resolvePackageStatusFromDeals(pkg.dealsCount, pkg.remainingDeals);
};
